import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageOut: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="package-out, return,delivery"><path d="M3.75 9.25V3.75H20.25V20.25H13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 3.75V9.25H15.25V3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.25 20.25V18C9.25 16.8954 8.35457 16 7.25 16H3M4.75 13.75L2.5 16L4.75 18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPackageOut;
